'use client';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/style/react/src/index.ts
import { StyleSheet as StyleSheet4, applyClassLabel, browserSupportsSelector, classNamePrefix, createEmotionInstance, createStyleSheet, cx as cx3, getEmotionInstance as getEmotionInstance3, getPadding, getSharedCssSheet, injectFont, injectGlobal, isCssPaddingProperty, srOnlyStyleSheet } from "@gs-ux-uitoolkit-common/style";

// components/style/react/src/emotion-instance-context.tsx
import { createContext, useContext } from "react";
import { getEmotionInstance } from "@gs-ux-uitoolkit-common/style";
import { jsx } from "react/jsx-runtime";
var EmotionInstanceContext = createContext(void 0);
var EmotionInstanceProvider = ({
  emotion,
  children
}) => {
  return jsx(EmotionInstanceContext.Provider, { value: emotion, children });
};
function useEmotionInstance() {
  return useContext(EmotionInstanceContext) || getEmotionInstance();
}

// components/style/react/src/global-styles.tsx
import { memo, useInsertionEffect } from "react";
import { isBrowser } from "@gs-ux-uitoolkit-common/shared";
var GlobalStyles = memo(({ styles }) => {
  const emotion = useEmotionInstance();
  if (!isBrowser) {
    emotion.injectGlobal(styles);
  } else {
    useInsertionEffect(() => {
      emotion.injectGlobal(styles);
    }, [emotion]);
  }
  return null;
});
GlobalStyles.displayName = "GlobalStyles";

// components/style/react/src/is-valid-html-prop.ts
import { default as default2 } from "@emotion/is-prop-valid";

// components/style/react/src/styled.tsx
import {
  forwardRef
} from "react";
import { cx, StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";

// components/style/react/src/use-style-sheet.ts
import { useContext as useContext2, useEffect, useRef } from "react";
import { getEmotionInstance as getEmotionInstance2 } from "@gs-ux-uitoolkit-common/style";
function useStyleSheet(jsStyleSheet, props) {
  const emotionInstance = useContext2(EmotionInstanceContext) || getEmotionInstance2();
  const stylesheetRef = useRef(jsStyleSheet);
  const componentKey = useRef({});
  if (stylesheetRef.current !== jsStyleSheet) {
    stylesheetRef.current.unmount(componentKey);
    stylesheetRef.current = jsStyleSheet;
  }
  const classes = stylesheetRef.current.mount(componentKey, props, emotionInstance);
  useEffect(() => {
    return () => {
      stylesheetRef.current.unmount(componentKey);
    };
  }, []);
  return classes;
}

// components/style/react/src/util/get-component-name.ts
function getComponentName(component) {
  return component.displayName || component.name;
}

// components/style/react/src/util/filter-props.ts
function filterProps(props, predicate) {
  const newPropsObj = {};
  for (const key of Object.keys(props)) {
    if (predicate(key)) {
      newPropsObj[key] = props[key];
    }
  }
  return newPropsObj;
}

// components/style/react/src/styled.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function styled(tagOrComponent, styles, { label, shouldForwardProp } = {}) {
  const styleSheetName = label || createStyleSheetName(tagOrComponent);
  const styleSheet = new StyleSheet2("", (props) => ({
    [styleSheetName]: typeof styles === "function" ? styles(props) : styles
  }));
  const StyleElement = tagOrComponent;
  const isHtmlElement = typeof tagOrComponent === "string";
  const Styled = forwardRef((props, ref) => {
    const classes = useStyleSheet(styleSheet, props);
    const propsFilterFn = shouldForwardProp || (isHtmlElement ? default2 : void 0);
    const propsWithRef = __spreadProps(__spreadValues({}, props), { ref });
    const filteredProps = propsFilterFn ? filterProps(propsWithRef, propsFilterFn) : propsWithRef;
    const finalProps = __spreadProps(__spreadValues({}, filteredProps), {
      className: cx(classes[styleSheetName], props.className)
    });
    return jsx2(StyleElement, __spreadProps(__spreadValues({}, finalProps), { children: props.children }));
  });
  Styled.displayName = "Styled";
  return Styled;
}
function createStyleSheetName(tagOrComponent) {
  if (typeof tagOrComponent === "string") {
    return tagOrComponent;
  } else {
    return getComponentName(tagOrComponent) || "styled";
  }
}

// components/style/react/src/styled-classes.tsx
import {
  forwardRef as forwardRef2
} from "react";
import {
  cx as cx2,
  StyleSheet as StyleSheet3
} from "@gs-ux-uitoolkit-common/style";
import { jsx as jsx3 } from "react/jsx-runtime";
function styledClasses(Component, classDefinitions, { label, shouldForwardProp } = {}) {
  const styleSheetName = label || getComponentName(Component) || "styled";
  const styleSheet = new StyleSheet3(
    styleSheetName,
    classDefinitions
  );
  const StyledClasses = forwardRef2((props, ref) => {
    const classes = useStyleSheet(styleSheet, props);
    const propsClasses = props.classes || {};
    const classNames = [...Object.keys(classes), ...Object.keys(propsClasses)];
    const dedupedClassNames = Array.from(new Set(classNames));
    const finalClasses = {};
    for (const className of dedupedClassNames) {
      finalClasses[className] = cx2(classes[className], propsClasses[className]);
    }
    const propsWithRef = __spreadProps(__spreadValues({}, props), { ref });
    const filteredProps = shouldForwardProp ? filterProps(propsWithRef, shouldForwardProp) : propsWithRef;
    const finalProps = __spreadProps(__spreadValues({}, filteredProps), {
      classes: finalClasses
    });
    return jsx3(Component, __spreadProps(__spreadValues({}, finalProps), { children: props.children }));
  });
  StyledClasses.displayName = "StyledClasses";
  return StyledClasses;
}
export {
  EmotionInstanceContext,
  EmotionInstanceProvider,
  GlobalStyles,
  StyleSheet4 as StyleSheet,
  applyClassLabel,
  browserSupportsSelector,
  classNamePrefix,
  createEmotionInstance,
  createStyleSheet,
  cx3 as cx,
  getEmotionInstance3 as getEmotionInstance,
  getPadding,
  getSharedCssSheet,
  injectFont,
  injectGlobal,
  isCssPaddingProperty,
  default2 as isValidHtmlProp,
  srOnlyStyleSheet,
  styled,
  styledClasses,
  useEmotionInstance,
  useStyleSheet
};
//# sourceMappingURL=index.mjs.map
